import { CalendarPageContents } from '@pages/(protected)/calendar/(index)/_calendar';
import React from 'react';

const CalendarPage = () => {
  return (
    <CalendarPageContents
      mode="all"
      hint="Meetings pertaining to all drugs."
    />
  );
};

export default CalendarPage;
